// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-for-group__checkbox___32ETL"};